import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "success-message-root q-pa-lg flex flex-center column" };
const _hoisted_2 = { class: "q-mt-lg text-h5 text-bold text-center" };
const _hoisted_3 = { class: "q-mt-sm text-body2 text-center text-grey-7" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'SuccessMessage',
    props: {
        message: {},
        title: {},
        buttonLabel: {}
    },
    emits: ["continue"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        return (_ctx, _cache) => {
            const _component_q_btn = _resolveComponent("q-btn");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "success-icon flex flex-center" }, [
                    _createElementVNode("svg", {
                        width: "80",
                        height: "80",
                        viewBox: "0 0 80 80",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                    }, [
                        _createElementVNode("circle", {
                            cx: "40",
                            cy: "40",
                            r: "40",
                            fill: "#388e3c22"
                        }),
                        _createElementVNode("path", {
                            d: "M28 41.5L37 50L53 34",
                            stroke: "#388e3c",
                            "stroke-width": "4",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                        })
                    ])
                ], -1)),
                _createElementVNode("div", _hoisted_2, _toDisplayString(props.title), 1),
                _createElementVNode("div", _hoisted_3, _toDisplayString(props.message), 1),
                _createVNode(_component_q_btn, {
                    class: "q-mt-xl",
                    color: "primary",
                    size: "md",
                    onClick: _cache[0] || (_cache[0] = ($event) => (emit('continue')))
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.buttonLabel), 1)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
